<template>
  <div class="userDetail">
    <div class="userDetail-header">
      <div class="display-flex center-flex header-title">
        <img src="@/assets/images/zhuanjia@2x.png" alt="" class="icon">
        <div class="title-wrap ml5">
          <span class="ghost-text">INTERVIEW</span>
          <div class="userDetail-label">数匠领袖专访</div>
        </div>
      </div>
      <div class="display-flex center-flex more-link">
        <GsMore muted @click="moreDetail">更多</GsMore>
      </div>
    </div>
    <GsSkeleton v-if="loading" :rows="4" />
    <div v-else-if="displayList.length > 0" class="userDetail-list">
      <div
        class="userDetail-content hand-cursor gs-card"
        v-for="(item, i) in displayList"
        :key="i"
        @click="nameDetail(item)"
      >
        <span class="exclusive-badge">独家专访</span>
        <span v-if="String(item.whetherTop)==='1'" class="is-top-badge">置顶</span>
        <img v-if="avatarSrc(item)" :src="avatarSrc(item)" alt="" class="img-pic"/>
        <div class="user-detail">
          <div class="userDetail-name ellipsis-one" :title="item.name + '：' + item.title">{{ item.name }}: {{ item.title}}</div>
          <div class="userDetail-characterIntroduction opa6"> {{ stripHtml(item.content) }}</div>
        </div>
      </div>
    </div>
    <no-data v-else/>
  </div>
</template>

<script>
import { interviewList } from "@/api/api";
import NoData from '@/components/NoData/index.vue'
import { P } from '@/router/paths'
export default {
  components: { NoData },
  data() {
    return {
      prodUrl:"https://shujuzichan.com/xwzx",
      loading: true,
      dataList: []
    };
  },
  props: {
    userDetailData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch:{
  },
  computed: {
    displayList() {
      const list = this.dataList || []
      if (typeof window !== 'undefined' && window.innerWidth < 960) {
        return list.slice(0, 3)
      }
      // 直接铺开，不滚动、不截断
      return list
    },
  },
  mounted() {
    this.init()
  },
  methods:{
    /** 数匠领袖位：优先用「数匠领袖专访」类别配图(1:1)，没有再用专家照片 */
    avatarSrc(item) {
      let url = ''
      const raw = item && item.categoryImages
      if (raw) {
        try {
          const map = typeof raw === 'object' ? raw : JSON.parse(String(raw))
          url = (map && map['3']) || ''
        } catch (e) { url = '' }
      }
      if (!url) url = (item && item.expertPicture) || ''
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      if (String(url).startsWith('/xwzx/')) return 'https://shujuzichan.com' + url
      return this.prodUrl + url
    },
    stripHtml(html) {
      if (!html) return ''
      return String(html).replace(/<[^>]*>/g, '')
    },
    init() {
      // 预览场景：外部直接传数据，就不再请求接口
      if (Array.isArray(this.userDetailData) && this.userDetailData.length) {
        this.dataList = this.userDetailData.slice(0, 5)
        this.loading = false
        return
      }
      var formData = {};
      formData["pageNum"]=1;
      formData["pageSize"]=5;
      formData["publishStatus"]=1
      interviewList(formData).then((response) => {
        this.dataList = (response.rows || []).slice(0, 5)
      }).finally(() => {
        this.loading = false
      })
    },
    moreDetail() {
      this.$router.push(P.interviews) 
    },
    nameDetail(item) {
      this.$router.push(P.interviewDetail(item.id)) 
    }
  }
};
</script>

<style scoped>
.userDetail {
  height: 100%;
  padding: 16px 14px;
  background: #F5F8FF;
  border-radius: 8px;
  overflow: hidden;
  box-sizing: border-box;
}
.userDetail-content {
  position: relative;
  margin-top: 12px;
  background: #EDF2FA;
  border-radius: 10px;
  overflow: hidden;
}
.exclusive-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  height: 22px;
  padding: 0 8px;
  border-radius: 4px;
  background: rgba(1, 101, 255, 0.92);
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.5px;
  pointer-events: none;
}
.icon {
  width: 32px;
  height: 28px;
  flex: 0 0 auto;
  object-fit: contain;
}
.userDetail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  min-width: 0;
}
.header-title {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
.title-wrap {
  position: relative;
  min-width: 0;
}
.ghost-text {
  position: absolute;
  left: 0;
  top: -8px;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: rgba(17, 24, 36, 0.08);
  pointer-events: none;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}
.more-link {
  color: #8A9099;
  flex: 0 0 auto;
  white-space: nowrap;
}
.more-text {
  color: #8A9099;
}
.userDetail-label {
  position: relative;
  z-index: 1;
  font-weight: 800;
  font-family: inherit;
  font-size: 18px;
  color: #111824;
  line-height: 24px;
  height: auto;
  text-align: left;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.more:hover {
    color:red;
}
.img-pic {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 320 / 160;
  object-fit: cover;
  object-position: center;
}
.user-detail{
  padding: 14px 16px 16px;
  background: #EDF2FA;
}
.user-detail div {
    /* line-height: 20px; */
}
.userDetail-name {
  height: 28px;
  font-family: AlibabaPuHuiTi_3_85_Bold;
  font-size: 20px;
  color: #111824;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  font-weight: 700;
}
.userDetail-position {
  font-size: 18px;
  margin-bottom: 2px;
  font-weight: 700;
  color: black;
  /* padding: 5px 0; */
}
.userDetail-characterIntroduction{
  margin-top: 5px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2; /* 限制为3行 */
  height: 44px;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 14px;
  color: #111824;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  /* color: #999999;
  font-size: 14px; */
}
@media (max-width: 960px) {
  .userDetail {
    padding: 10px 8px;
    border-radius: 12px;
    overflow: hidden;
  }
  .ghost-text {
    font-size: 14px;
    letter-spacing: 0.06em;
    opacity: 0.16;
  }
  .userDetail-label {
    font-size: 15px;
    line-height: 22px;
  }
  .userDetail-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .userDetail-content {
    margin: 0;
    border-radius: 10px;
    overflow: hidden;
  }
  .userDetail-content:hover {
    transform: none;
  }
  .img-pic {
    height: 84px;
    object-fit: cover;
  }
  .userDetail-name {
    font-size: 12px;
    height: auto;
    line-height: 1.35;
    -webkit-line-clamp: 2;
  }
  .userDetail-characterIntroduction {
    font-size: 11px;
    line-height: 1.35;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .user-detail {
    padding: 8px;
  }
}

.is-top-badge { position:absolute; right:8px; top:8px; z-index:2; padding:1px 6px; font-size:12px; color:#fff; background:#D9001B; border-radius:4px; }
</style>